import { IState, IImagePopup, ISetActiveMenuItem } from './state'
import { ActionTree, Store, ActionContext } from 'vuex'

type PayloadType =
  | 'initState'
  | 'showMenu'
  | 'hideMenu'
  | 'preLoadHeroes'
  | 'toggleMenuItem'
  | 'imagePopup'
  | 'setActiveMenuItem'
export type ActionPayload<ActionData> = {
  type: PayloadType
  payload: ActionData
}

type ActionHandler<ActionData> = (
  this: Store<IState>,
  injectee: ActionContext<IState, IState>,
  payload: ActionPayload<ActionData>
) => any
type ActionCreator<ActionData> = (data: ActionData) => ActionPayload<ActionData>

// Action creators
export const initState: ActionCreator<IState> = state => ({
  type: 'initState',
  payload: state
})

export const showMenu: ActionCreator<IState> = state => ({
  type: 'showMenu',
  payload: state
})

export const hideMenu: ActionCreator<IState> = state => ({
  type: 'hideMenu',
  payload: state
})

export const preLoadHeroes: ActionCreator<IState> = state => ({
  type: 'preLoadHeroes',
  payload: state
})

export const imagePopup: ActionCreator<IState> = state => ({
  type: 'imagePopup',
  payload: state
})
export const setActiveMenuItem: ActionCreator<IState> = state => ({
  type: 'setActiveMenuItem',
  payload: state
})

// Action handlers
const initStateAction: ActionHandler<IState> = ({ commit }, { payload }) => {
  commit({
    type: 'initState',
    payload
  })
}

const showMenuAction: ActionHandler<IState> = ({ commit }, { payload }) => {
  commit({
    type: 'changeMenu',
    payload: { action: 'show' }
  })
}
const hideMenuAction: ActionHandler<IState> = ({ commit }, { payload }) => {
  commit({
    type: 'changeMenu',
    payload: { action: 'hide' }
  })
}
const preLoadHeroesAction: ActionHandler<any> = (
  { state, commit },
  { payload }
) => {
  let thisPage = state.pagesContent.find(
    (item: any) => item.path === payload.to
  )
  let index: number = thisPage ? state.pagesContent.indexOf(thisPage) : 0

  let siblingIndexes = [index + 1, index - 1]
  let siblingImages: string[] = []

  siblingIndexes.forEach(index => {
    if (state.pagesContent[index]) {
      let item = state.pagesContent[index] as any
      if (item.image) siblingImages.push(item.image.url)
    }
  })

  siblingImages.forEach(heroImage => {
    const loader = new Image()
    loader.src = heroImage
  })
}
const toggleMenuItemAction: ActionHandler<IState> = (
  { commit },
  { payload }
) => {
  commit({
    type: 'toggleMenuItem',
    payload
  })
}
const imagePopupAction: ActionHandler<IImagePopup> = (
  { commit },
  { payload }
) => {
  commit({
    type: 'imagePopup',
    payload
  })
}
const setActiveMenuItemAction: ActionHandler<ISetActiveMenuItem> = (
  { state, commit },
  { payload }
) => {
  commit({ type: 'setActiveMenuItem', payload })
}

const actions: ActionTree<IState, IState> = {
  initState: initStateAction,
  preLoadHeroes: preLoadHeroesAction,
  showMenu: showMenuAction,
  hideMenu: hideMenuAction,
  toggleMenuItem: toggleMenuItemAction,
  imagePopup: imagePopupAction,
  setActiveMenuItem: setActiveMenuItemAction
}

export default actions
